<script setup lang="ts">
import { isDefined } from "@vueuse/core"
import { useRouteQuery } from "@vueuse/router"
import { TavoButton } from "~/components/tavo"
import { useTavoConfig } from "~/components/tavo/config"
import { useLocation } from "~/composables/locations"
import { kebabCase } from "~/lib/case"
import { ReservationDialog } from "."

const tavoConfig = useTavoConfig()
const tavoButton = useTemplateRef("tavoButton")
const tavoReady = computed(() => isDefined(tavoButton) && tavoButton.value.ready)

const { location } = useLocation()
const locationKey = computed(() => {
    if (isDefined(location)) {
        return kebabCase(location.value.name)
    }
})

const modal = useRouteQuery("modal")
watch(tavoReady, (value) => {
    if (value) {
        if (modal.value === "reservations") {
            tavoButton.value!.click()
            modal.value = undefined
        }
    }
}, { immediate: true })


</script>

<template>
    <TavoButton
        v-if="tavoConfig"
        ref="tavoButton"
        :group="tavoConfig.group"
        :concept="tavoConfig.concept"
        :location="locationKey"
    >
        <slot />
    </TavoButton>
    <ReservationDialog v-else>
        <slot />
    </ReservationDialog>
</template>